import React, { useState } from 'react';
import './register.css';
import { useTranslation } from 'react-i18next';
import googleIcon from './icons/google-svgrepo-com.svg';
import OtpModal from './OtpModal';
import axios from 'axios';
import API_URL from '../../utility/api';
import { handleApiPostRequest } from '../../utility/handleApiRequest';
import { GoogleLogin } from '@react-oauth/google';
import { Link, useNavigate } from 'react-router-dom';
import myImage from '../../assets/images/bank_logo.png';
import { useData } from '../../context/AdharDataContext';

function Register() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setUserData } = useData();
    const [contact, setContact] = useState('');
    const [isContactValid, setIsContactValid] = useState(false);
    const [pincode, setPincode] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpData, setOtpData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleContactChange = (event) => {
        const input = event.target.value.replace(/\D/g, '');
        const truncatedInput = input.slice(0, 10);
        const formattedInput = formatPhoneNumber(truncatedInput);
        setContact(formattedInput);
        setIsContactValid(validatePhone(truncatedInput));
    };

    const validatePhone = (phone) => {
        const regex = /^\d{10}$/;
        return regex.test(phone);
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (phoneNumber.length > 5) {
            return phoneNumber.slice(0, 5) + '-' + phoneNumber.slice(5, 10);
        }
        return phoneNumber;
    };

    const handlePincodeChange = (event) => {
        setPincode(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const url = API_URL + '/Register/GenerateEmailAndPhoneOtp';
            const postData = {
                phonenumber: contact.replace('-', ''),
            };
            const data = await handleApiPostRequest(url, postData);
            setOtpData(data);
            setShowOtpModal(true);
            setUserData({ phoneNumber: contact.replace('-', '') });
        } catch (error) {
            console.error('Error generating OTP:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Update button disabled state based on contact validity and loading
    React.useEffect(() => {
        setButtonDisabled(!isContactValid || isLoading);
    }, [isContactValid, isLoading]);

    return (
        <>
            <div className='bank-logo-container'>
                <img className='bank-logo' src={myImage} alt="Bank Logo" />
            </div>
            <div className='register-container'>
                <div className='register-form'>
                    <div className='form-container'>
                        <form onSubmit={handleSubmit}>
                            <div className='form-field'>
                                <label htmlFor="contact">{t('contact')}:</label>
                                <span className='contact-field'>
                                    <input
                                        type='text'
                                        className='countrycode'
                                        value={t('mobileNumberPrefix')}
                                        readOnly
                                    />
                                    <input
                                        type="tel"
                                        id='contact'
                                        value={contact}
                                        onChange={handleContactChange}
                                        placeholder={t('phoneNumber')}
                                        maxLength={12} // 10 digits + hyphen
                                    />
                                </span>
                                {contact && !isContactValid && (
                                    <p style={{ color: 'red' }}>{t('invalidPhone')}</p>
                                )}
                            </div>
                            <div className='form-field'>
                                <label htmlFor="pincode">{t('pincode')}:</label>
                                <span className='contact-field'>
                                    <input
                                        type='text'
                                        id='pincode'
                                        placeholder={t('pincode')}
                                        value={pincode}
                                        onChange={handlePincodeChange}
                                    />
                                </span>
                                <p className='pincode-note'>{t('pincodeSuggestion')}</p>
                            </div>
                            <div className='agreement'>
                                {t('RegisterTermsAndCond')} <br />
                                <span>{t('TermsAndConditions')}</span> {t('AndLabel')}{' '}
                                <span>{t('PrivacyPolicy')}</span>
                            </div>
                            <button className='btn' disabled={buttonDisabled}>
                                {isLoading ? t('Loading...') : t('Open')}
                            </button>
                        </form>
                    </div>
                </div>
                <div className='register-text'>
                    <div className='hero-text'>
                        <h1>{t('herotext')}</h1>
                    </div>
                </div>
            </div>
            {showOtpModal && (
                <OtpModal
                    contact={contact.replace('-', '')}
                    otpData={otpData}
                    setUserData={setUserData}
                    setShowOtpModal={setShowOtpModal}
                />
            )}
        </>
    );
}

export default Register;